export default __webpack_public_path__ + "static/modern-kitchen-hero-f679213881c766cd1a8a4d13db4dcc57.png";